import { MenuItem } from "@bruisedears/app-lib"

export const menuData = {
  events: {
    title: 'What\'s on',
    route: 'happening',
    icon: 'event'
  },
  games: {
    title: 'Games',
    route: 'games/tba',
    icon: 'emoji_events'
  },
  you: {
    title: 'You',
    route: 'you',
    icon: 'star'
  },
  other: {
    title: 'Other',
    route: 'other',
    icon: 'deployed_code'
  }
};
